import axios from 'axios';
import { AAP_BASE_URL, NODE_BASE_URL } from 'src/config';

const axiosAuth = axios.create({
  baseURL: AAP_BASE_URL,

  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
  },
});

axiosAuth.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const token = localStorage.getItem('token');
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosAuth.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log('error status', error.response?.status);

    if (error.response?.status === 401) {
      // Clear token and other user-specific data

      localStorage.removeItem('data');
      localStorage.removeItem('token');
      // Optionally show a logout message
      alert('Session expired. Please log in again.');

      // Redirect user to the login page
      window.location.href = '/login/admin'; // Update the path to match your app's login route
    }

    return Promise.reject(error);
  }
);

const axiosAuthAirmail = axios.create({
  baseURL: NODE_BASE_URL,

  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
  },
});

axiosAuthAirmail.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const token = localStorage.getItem('token');
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.XCustomHeader = 'c41e86207c16d42b4d2f432c620134d9'; // Additional header
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosAuthAirmail.interceptors.response.use(
  (response) => response,
  async () => {
    return Promise.reject();
  }
);

// Mapping keys to instances
export const axiosInstances = {
  auth: axiosAuth, // Default authenticated requests
  airmail: axiosAuthAirmail, // Public API requests
};
